import React from "react";

interface NotFoundProps {}

const NotFound: React.FC<NotFoundProps> = () => {
  return (
    <div>
      <h1>页面未找到</h1>
    </div>
  );
};

export default NotFound;
